/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import classNames from "classnames";
import { FormGroup, Input, Label } from "reactstrap";
import TextArea from "antd/es/input/TextArea";

function SimpleInputField(props) {
  const {
    label,
    fieldType = "text",
    fieldName,
    isDisabled = false,
    isReadOnly = false,
    value,
    placeholder,
    onChangeAction,
    isMultiple = false,
    commonSelect,
    selectOption,
    minDate,
    maxDate,
    isFormGrop = true,
  } = props;

  const config =
    fieldType === "select"
      ? {
        type: "select",
        component: "select",
      }
      : fieldType === "number"
        ? {
          type: fieldType,
          min: "0",
        }
        : fieldType === "date"
          ? {
            type: fieldType,
            min: minDate,
            max: maxDate,
          }
          : {
            type: fieldType,
          };

  return isFormGrop ? (
    <FormGroup>
      {label && <Label>{label}</Label>}
      {fieldType === "select" ? (
        <Input
          {...config}
          multiple={isMultiple}
          name={fieldName}
          disabled={isDisabled}
          readOnly={isReadOnly}
          placeholder={placeholder}
          className={classNames("form-control text-black reactSelect")}
          value={value}
          onChange={(e) => onChangeAction(e.target.value)}
        >
          {commonSelect && <option value="">{commonSelect}</option>}
          {!_.isEmpty(selectOption) &&
            _.map(selectOption, (val) => (
              <option value={val.id} key={`fieldName-${val.id}`}>
                {val.title}
              </option>
            ))}
        </Input>
      ) : (
        <Input
          {...config}
          name={fieldName}
          disabled={isDisabled}
          readOnly={isReadOnly}
          className={classNames("form-control text-black")}
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChangeAction(e.target.value)}
        />
      )}
    </FormGroup>
  ) : (
    <>
      {label && <Label>{label}</Label>}
      {fieldType === "select" ? (
        <Input
          {...config}
          multiple={isMultiple}
          name={fieldName}
          disabled={isDisabled}
          readOnly={isReadOnly}
          placeholder={placeholder}
          className={classNames("form-control text-black")}
          value={value}
          onChange={(e) => onChangeAction(e.target.value)}
        >
          {commonSelect && <option value="">{commonSelect}</option>}
          {!_.isEmpty(selectOption) &&
            _.map(selectOption, (val) => (
              <option value={val.id} key={`fieldName-${val.id}`}>
                {val.title}
              </option>
            ))}
        </Input>
      ) : (
        <Input
          {...config}
          name={fieldName}
          disabled={isDisabled}
          readOnly={isReadOnly}
          className={classNames("form-control text-black")}
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChangeAction(e.target.value)}
        />
      )}
    </>
  );
}

SimpleInputField.propTypes = {
  onChangeAction: PropTypes.func,
  value: PropTypes.any,
  selectOption: PropTypes.any,
  label: PropTypes.string,
  fieldType: PropTypes.string,
  fieldName: PropTypes.string,
  isDisabled: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  isMultiple: PropTypes.bool,
  commonSelect: PropTypes.string,
  placeholder: PropTypes.string,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
};

export default SimpleInputField;


export const SimpleTextareaInputField = (props) => {
  const {
    label,
    fieldName,
    value,
    onChangeAction,
    rows = "2",
    maxLength,
    isDisabled = false,
    showCount = false,
  } = props;

  const config = useMemo(() => {
    const data = {
      rows,
    };
    if (maxLength) {
      data.maxLength = maxLength;
    }
    if (showCount) {
      data.count = {
        show: true,
      };
      if (maxLength) {
        data.count.max = maxLength;
      }
    }
    return data;
  }, []);

  return (
    <FormGroup>
      {label && <Label className="text-black fw-normal">{label}</Label>}
      <TextArea
        {...config}
        name={fieldName}
        onChange={(event) => {
          onChangeAction(event.currentTarget.value);
        }}
        className="form-control"
        disabled={isDisabled}
        value={value}
        autoSize={{
          minRows: 2,
          maxRows: 2,
        }}
      />
    </FormGroup>
  );
};

SimpleTextareaInputField.propTypes = {
  label: PropTypes.string,
  fieldName: PropTypes.string,
  value: PropTypes.string,
  onChangeAction: PropTypes.func,
  rows: PropTypes.string,
  maxLength: PropTypes.string,
  showCount: PropTypes.bool,
  isDisabled: PropTypes.bool,
};